/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChartDataRepresentation,
  ChartDataRequest,
  DeleteReImportRequest,
  GaugeDataRepresentation,
  GaugeDataRequest,
  LatestLogDataRequest,
  LogDataRepresentation,
  LogDataRequest,
  OperatorPrognosisMonetaryRepresentation,
  OperatorPrognosisMonetaryRequest,
  PieDataRepresentation,
  PieDataRequest,
  PowercurveDataRepresentation,
  PowercurveDataRequest,
  ReImportMarkerRepresentation,
  ReImportRequest,
  ScatterDataRepresentation,
  ScatterDataRequest,
  StreamingResponseBody,
  WindroseDataRepresentation,
  WindroseDataRequest,
} from '../models/index';
import {
    ChartDataRepresentationFromJSON,
    ChartDataRepresentationToJSON,
    ChartDataRequestFromJSON,
    ChartDataRequestToJSON,
    DeleteReImportRequestFromJSON,
    DeleteReImportRequestToJSON,
    GaugeDataRepresentationFromJSON,
    GaugeDataRepresentationToJSON,
    GaugeDataRequestFromJSON,
    GaugeDataRequestToJSON,
    LatestLogDataRequestFromJSON,
    LatestLogDataRequestToJSON,
    LogDataRepresentationFromJSON,
    LogDataRepresentationToJSON,
    LogDataRequestFromJSON,
    LogDataRequestToJSON,
    OperatorPrognosisMonetaryRepresentationFromJSON,
    OperatorPrognosisMonetaryRepresentationToJSON,
    OperatorPrognosisMonetaryRequestFromJSON,
    OperatorPrognosisMonetaryRequestToJSON,
    PieDataRepresentationFromJSON,
    PieDataRepresentationToJSON,
    PieDataRequestFromJSON,
    PieDataRequestToJSON,
    PowercurveDataRepresentationFromJSON,
    PowercurveDataRepresentationToJSON,
    PowercurveDataRequestFromJSON,
    PowercurveDataRequestToJSON,
    ReImportMarkerRepresentationFromJSON,
    ReImportMarkerRepresentationToJSON,
    ReImportRequestFromJSON,
    ReImportRequestToJSON,
    ScatterDataRepresentationFromJSON,
    ScatterDataRepresentationToJSON,
    ScatterDataRequestFromJSON,
    ScatterDataRequestToJSON,
    StreamingResponseBodyFromJSON,
    StreamingResponseBodyToJSON,
    WindroseDataRepresentationFromJSON,
    WindroseDataRepresentationToJSON,
    WindroseDataRequestFromJSON,
    WindroseDataRequestToJSON,
} from '../models/index';

export interface CreateDataReImportRequest {
    reImportRequest: ReImportRequest;
}

export interface DeleteDataReImportsRequest {
    deleteReImportRequest: DeleteReImportRequest;
}

export interface GetChartDataRequest {
    chartDataRequest: ChartDataRequest;
}

export interface GetChartDataAsCSVRequest {
    chartDataRequest: ChartDataRequest;
}

export interface GetGaugeDataRequest {
    gaugeDataRequest: GaugeDataRequest;
}

export interface GetLatestLogDataRequest {
    latestLogDataRequest: LatestLogDataRequest;
}

export interface GetLogDataRequest {
    logDataRequest: LogDataRequest;
}

export interface GetOperatorPrognosisMonetaryRequest {
    operatorPrognosisMonetaryRequest: OperatorPrognosisMonetaryRequest;
}

export interface GetPieDataRequest {
    pieDataRequest: PieDataRequest;
}

export interface GetPowercurveDataRequest {
    powercurveDataRequest: PowercurveDataRequest;
}

export interface GetScatterDataRequest {
    scatterDataRequest: ScatterDataRequest;
}

export interface GetWindroseDataRequest {
    windroseDataRequest: WindroseDataRequest;
}

export interface UploadCSVDataRequest {
    type: UploadCSVDataTypeEnum;
    data: Blob;
    year?: number;
}

export interface UploadSolarParkDataRequest {
    parkMasterData: Blob;
    parkDataMonthly: Blob;
    parkDataDaily: Blob;
}

/**
 * 
 */
export class DataApi extends runtime.BaseAPI {

    /**
     * Mark an interval for reimport
     * Mark an interval for reimport
     */
    async createDataReImportRaw(requestParameters: CreateDataReImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reImportRequest'] == null) {
            throw new runtime.RequiredError(
                'reImportRequest',
                'Required parameter "reImportRequest" was null or undefined when calling createDataReImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/data/reimports`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReImportRequestToJSON(requestParameters['reImportRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark an interval for reimport
     * Mark an interval for reimport
     */
    async createDataReImport(reImportRequest: ReImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDataReImportRaw({ reImportRequest: reImportRequest }, initOverrides);
    }

    /**
     * Delete list of reimport markers
     * Delete reimport markers
     */
    async deleteDataReImportsRaw(requestParameters: DeleteDataReImportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deleteReImportRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteReImportRequest',
                'Required parameter "deleteReImportRequest" was null or undefined when calling deleteDataReImports().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/data/reimports`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteReImportRequestToJSON(requestParameters['deleteReImportRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete list of reimport markers
     * Delete reimport markers
     */
    async deleteDataReImports(deleteReImportRequest: DeleteReImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDataReImportsRaw({ deleteReImportRequest: deleteReImportRequest }, initOverrides);
    }

    /**
     * Returns chart data for datarequest
     * Returns chart data
     */
    async getChartDataRaw(requestParameters: GetChartDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChartDataRepresentation>>> {
        if (requestParameters['chartDataRequest'] == null) {
            throw new runtime.RequiredError(
                'chartDataRequest',
                'Required parameter "chartDataRequest" was null or undefined when calling getChartData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/chart`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChartDataRequestToJSON(requestParameters['chartDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChartDataRepresentationFromJSON));
    }

    /**
     * Returns chart data for datarequest
     * Returns chart data
     */
    async getChartData(chartDataRequest: ChartDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChartDataRepresentation>> {
        const response = await this.getChartDataRaw({ chartDataRequest: chartDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns chart data as CSV export
     * Returns chart data as CSV
     */
    async getChartDataAsCSVRaw(requestParameters: GetChartDataAsCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['chartDataRequest'] == null) {
            throw new runtime.RequiredError(
                'chartDataRequest',
                'Required parameter "chartDataRequest" was null or undefined when calling getChartDataAsCSV().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/csv/chart`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChartDataRequestToJSON(requestParameters['chartDataRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Returns chart data as CSV export
     * Returns chart data as CSV
     */
    async getChartDataAsCSV(chartDataRequest: ChartDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getChartDataAsCSVRaw({ chartDataRequest: chartDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns gauge data for datarequest
     * Returns gauge data
     */
    async getGaugeDataRaw(requestParameters: GetGaugeDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GaugeDataRepresentation>> {
        if (requestParameters['gaugeDataRequest'] == null) {
            throw new runtime.RequiredError(
                'gaugeDataRequest',
                'Required parameter "gaugeDataRequest" was null or undefined when calling getGaugeData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/gauge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GaugeDataRequestToJSON(requestParameters['gaugeDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GaugeDataRepresentationFromJSON(jsonValue));
    }

    /**
     * Returns gauge data for datarequest
     * Returns gauge data
     */
    async getGaugeData(gaugeDataRequest: GaugeDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GaugeDataRepresentation> {
        const response = await this.getGaugeDataRaw({ gaugeDataRequest: gaugeDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns log data for datarequest
     * Returns latest log entries
     */
    async getLatestLogDataRaw(requestParameters: GetLatestLogDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LogDataRepresentation>>> {
        if (requestParameters['latestLogDataRequest'] == null) {
            throw new runtime.RequiredError(
                'latestLogDataRequest',
                'Required parameter "latestLogDataRequest" was null or undefined when calling getLatestLogData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/log/latest`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LatestLogDataRequestToJSON(requestParameters['latestLogDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LogDataRepresentationFromJSON));
    }

    /**
     * Returns log data for datarequest
     * Returns latest log entries
     */
    async getLatestLogData(latestLogDataRequest: LatestLogDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LogDataRepresentation>> {
        const response = await this.getLatestLogDataRaw({ latestLogDataRequest: latestLogDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns log data for datarequest
     * Returns log data
     */
    async getLogDataRaw(requestParameters: GetLogDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingResponseBody>> {
        if (requestParameters['logDataRequest'] == null) {
            throw new runtime.RequiredError(
                'logDataRequest',
                'Required parameter "logDataRequest" was null or undefined when calling getLogData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/log`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogDataRequestToJSON(requestParameters['logDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingResponseBodyFromJSON(jsonValue));
    }

    /**
     * Returns log data for datarequest
     * Returns log data
     */
    async getLogData(logDataRequest: LogDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingResponseBody> {
        const response = await this.getLogDataRaw({ logDataRequest: logDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns operator prognosis monetary
     * Returns operator prognosis monetary
     */
    async getOperatorPrognosisMonetaryRaw(requestParameters: GetOperatorPrognosisMonetaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperatorPrognosisMonetaryRepresentation>> {
        if (requestParameters['operatorPrognosisMonetaryRequest'] == null) {
            throw new runtime.RequiredError(
                'operatorPrognosisMonetaryRequest',
                'Required parameter "operatorPrognosisMonetaryRequest" was null or undefined when calling getOperatorPrognosisMonetary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/operator-prognosis-monetary`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OperatorPrognosisMonetaryRequestToJSON(requestParameters['operatorPrognosisMonetaryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperatorPrognosisMonetaryRepresentationFromJSON(jsonValue));
    }

    /**
     * Returns operator prognosis monetary
     * Returns operator prognosis monetary
     */
    async getOperatorPrognosisMonetary(operatorPrognosisMonetaryRequest: OperatorPrognosisMonetaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperatorPrognosisMonetaryRepresentation> {
        const response = await this.getOperatorPrognosisMonetaryRaw({ operatorPrognosisMonetaryRequest: operatorPrognosisMonetaryRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Get list of reimport markers for all generators of user
     * Get reimport markers
     */
    async getPendingDataReImportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReImportMarkerRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/data/reimports`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReImportMarkerRepresentationFromJSON));
    }

    /**
     * Get list of reimport markers for all generators of user
     * Get reimport markers
     */
    async getPendingDataReImports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReImportMarkerRepresentation>> {
        const response = await this.getPendingDataReImportsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns pie data for datarequest
     * Returns pie data
     */
    async getPieDataRaw(requestParameters: GetPieDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PieDataRepresentation>> {
        if (requestParameters['pieDataRequest'] == null) {
            throw new runtime.RequiredError(
                'pieDataRequest',
                'Required parameter "pieDataRequest" was null or undefined when calling getPieData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/pie`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PieDataRequestToJSON(requestParameters['pieDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PieDataRepresentationFromJSON(jsonValue));
    }

    /**
     * Returns pie data for datarequest
     * Returns pie data
     */
    async getPieData(pieDataRequest: PieDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PieDataRepresentation> {
        const response = await this.getPieDataRaw({ pieDataRequest: pieDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns powercurve data for datarequest
     * Returns powercurve data
     */
    async getPowercurveDataRaw(requestParameters: GetPowercurveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PowercurveDataRepresentation>>> {
        if (requestParameters['powercurveDataRequest'] == null) {
            throw new runtime.RequiredError(
                'powercurveDataRequest',
                'Required parameter "powercurveDataRequest" was null or undefined when calling getPowercurveData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/powercurve`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PowercurveDataRequestToJSON(requestParameters['powercurveDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PowercurveDataRepresentationFromJSON));
    }

    /**
     * Returns powercurve data for datarequest
     * Returns powercurve data
     */
    async getPowercurveData(powercurveDataRequest: PowercurveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PowercurveDataRepresentation>> {
        const response = await this.getPowercurveDataRaw({ powercurveDataRequest: powercurveDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns scatter data for datarequest
     * Returns scatter data
     */
    async getScatterDataRaw(requestParameters: GetScatterDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ScatterDataRepresentation>>> {
        if (requestParameters['scatterDataRequest'] == null) {
            throw new runtime.RequiredError(
                'scatterDataRequest',
                'Required parameter "scatterDataRequest" was null or undefined when calling getScatterData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/scatter`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScatterDataRequestToJSON(requestParameters['scatterDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScatterDataRepresentationFromJSON));
    }

    /**
     * Returns scatter data for datarequest
     * Returns scatter data
     */
    async getScatterData(scatterDataRequest: ScatterDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ScatterDataRepresentation>> {
        const response = await this.getScatterDataRaw({ scatterDataRequest: scatterDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Returns wind rose data for datarequest
     * Returns wind rose data
     */
    async getWindroseDataRaw(requestParameters: GetWindroseDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WindroseDataRepresentation>> {
        if (requestParameters['windroseDataRequest'] == null) {
            throw new runtime.RequiredError(
                'windroseDataRequest',
                'Required parameter "windroseDataRequest" was null or undefined when calling getWindroseData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/windrose`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WindroseDataRequestToJSON(requestParameters['windroseDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WindroseDataRepresentationFromJSON(jsonValue));
    }

    /**
     * Returns wind rose data for datarequest
     * Returns wind rose data
     */
    async getWindroseData(windroseDataRequest: WindroseDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WindroseDataRepresentation> {
        const response = await this.getWindroseDataRaw({ windroseDataRequest: windroseDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Upload CSV data time series
     * Upload CSV data
     */
    async uploadCSVDataRaw(requestParameters: UploadCSVDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling uploadCSVData().'
            );
        }

        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling uploadCSVData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["generators:write"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['type'] != null) {
            formParams.append('type', requestParameters['type'] as any);
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', requestParameters['data'] as any);
        }

        if (requestParameters['year'] != null) {
            formParams.append('year', requestParameters['year'] as any);
        }


        let urlPath = `/data/import/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload CSV data time series
     * Upload CSV data
     */
    async uploadCSVData(type: UploadCSVDataTypeEnum, data: Blob, year?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadCSVDataRaw({ type: type, data: data, year: year }, initOverrides);
        return await response.value();
    }

    /**
     * Upload CSV data for a solar park
     * Upload solar park data
     */
    async uploadSolarParkDataRaw(requestParameters: UploadSolarParkDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['parkMasterData'] == null) {
            throw new runtime.RequiredError(
                'parkMasterData',
                'Required parameter "parkMasterData" was null or undefined when calling uploadSolarParkData().'
            );
        }

        if (requestParameters['parkDataMonthly'] == null) {
            throw new runtime.RequiredError(
                'parkDataMonthly',
                'Required parameter "parkDataMonthly" was null or undefined when calling uploadSolarParkData().'
            );
        }

        if (requestParameters['parkDataDaily'] == null) {
            throw new runtime.RequiredError(
                'parkDataDaily',
                'Required parameter "parkDataDaily" was null or undefined when calling uploadSolarParkData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["generators:write"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['parkMasterData'] != null) {
            formParams.append('parkMasterData', requestParameters['parkMasterData'] as any);
        }

        if (requestParameters['parkDataMonthly'] != null) {
            formParams.append('parkDataMonthly', requestParameters['parkDataMonthly'] as any);
        }

        if (requestParameters['parkDataDaily'] != null) {
            formParams.append('parkDataDaily', requestParameters['parkDataDaily'] as any);
        }


        let urlPath = `/data/import/solarparks`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload CSV data for a solar park
     * Upload solar park data
     */
    async uploadSolarParkData(parkMasterData: Blob, parkDataMonthly: Blob, parkDataDaily: Blob, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadSolarParkDataRaw({ parkMasterData: parkMasterData, parkDataMonthly: parkDataMonthly, parkDataDaily: parkDataDaily }, initOverrides);
    }

}

/**
 * @export
 */
export const UploadCSVDataTypeEnum = {
    MonthlyPlan: 'monthly_plan',
    MonthlyPlanBasicData: 'monthly_plan_basic_data',
    CommissionMarketvalues: 'commission_marketvalues',
    EnergyIndexPlzIwet: 'energy_index_plz_iwet',
    EnergyIndexValueIwet: 'energy_index_value_iwet'
} as const;
export type UploadCSVDataTypeEnum = typeof UploadCSVDataTypeEnum[keyof typeof UploadCSVDataTypeEnum];
